import * as React from 'react';
import { useLocation, useHistory } from 'react-router-dom';

interface SearchParams {
  [key: string]: any;
}

export const useSearchParams = () => {
  const { search, pathname } = useLocation();
  const history = useHistory();
  const searchParams = React.useMemo(
    () => new URLSearchParams(search),
    [search]
  );

  function onUpdateSearchParam(inputSearchParams: SearchParams) {
    history.push({
      pathname,
      search:
        '?' +
        Object.entries(inputSearchParams).reduce(
          (acc, [key, value]) =>
            acc ? `${acc}&${key}=${value}` : `${key}=${value}`,
          ''
        ),
    });
  }

  return { searchParams, onUpdateSearchParam };
};
